import BaseCommand from "@/models/api/commands/BaseCommand";

export class GetAttributesCommand extends BaseCommand {
  CommandName = "GetAttributes";
  Command: { BookingItemTmpId: string };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId };
  }
}
